// extracted by mini-css-extract-plugin
export var button = "_ml-2";
export var card = "_ml-0";
export var closeButtonContainer = "_ml-3";
export var iconContainer = "_ml-1";